/** Stored on a verified address whose line 2 USPS didn't use, so it was kept as typed. */
export const ADDRESS_LINE2_KEPT_MESSAGE =
  "Address line 2 was kept as the customer entered it because USPS didn't use it";
